import { useEffect, useState } from 'react';
import { UserFetchJson } from '../userFetch';

let cachedNames: string[] | null = null;
let fetchPromise: Promise<string[]> | null = null;

export function invalidateOwnerNamesCache() {
    cachedNames = null;
    fetchPromise = null;
}

function fetchOwnerNames(): Promise<string[]> {
    if (!fetchPromise) {
        fetchPromise = UserFetchJson('/api/owner-names')
            .then((names: string[]) => {
                cachedNames = names;
                return names;
            })
            .catch(() => {
                fetchPromise = null;
                return [];
            });
    }
    return fetchPromise;
}

export default function useOwnerNames() {
    const [ownerNames, setOwnerNames] = useState<string[]>(cachedNames || []);
    const [loading, setLoading] = useState(!cachedNames);

    useEffect(() => {
        if (cachedNames) {
            setOwnerNames(cachedNames);
            setLoading(false);
            return;
        }

        fetchOwnerNames().then(names => {
            setOwnerNames(names);
            setLoading(false);
        });
    }, []);

    return { ownerNames, loading };
}
